import React, { useState } from "react";
import { useSelector } from "react-redux";
import NavigationDrawer from "./NavigationDrawer";
import NotificationBadge from "./ui/NotificationBadge";
import Notifications from "../features/notifications/Notifications";
import { useTheme } from "../contexts/ThemeContext";
import { Button } from "./ui/button";
import { Menu, Sun, Moon } from "lucide-react";
import { useApp } from "../contexts/AppContext";

export function Layout({ children, title = "TechDispatch", onNavigate }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();
  const { user } = useApp();

  const notifications = useSelector((state) => state.notifications.items);
  const unreadCount = notifications
    ? notifications.filter((n) => !n.isRead).length
    : 0;
  const toggleNotifications = () => setNotificationsOpen((o) => !o);

  const handleNotificationSelect = (appointmentId) => {
    onNavigate("appointmentJob", appointmentId);
    setNotificationsOpen(false);
  };

  return (
    <div className="min-h-screen bg-background relative">
      {/* Header */}
      <header className="flex items-center justify-between bg-white dark:bg-gray-800 shadow px-4 py-3">
        <div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setDrawerOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="ml-4 font-semibold text-lg">{title}</span>
        </div>

        <div className="flex items-center space-x-4">
          <NotificationBadge
            count={unreadCount}
            onClick={toggleNotifications}
            aria-label="Notifications"
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {isDarkMode ? (
              <Sun className="h-5 w-5" />
            ) : (
              <Moon className="h-5 w-5" />
            )}
          </Button>
        </div>
      </header>

      {/* Notification Drawer */}
      <Notifications
        technicianId={user?.employeeid}
        isOpen={notificationsOpen}
        onClose={() => setNotificationsOpen(false)}
        onNavigate={handleNotificationSelect}
      />

      {/* Navigation Drawer */}
      <NavigationDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onNavigate={onNavigate}
      />

      {/* Main content */}
      <main className="p-4">{children}</main>
    </div>
  );
}
